<template>
  <el-dialog
    title=""
    :visible.sync="visible"
    append-to-body
    :show-close="false"
    width="413px"
    custom-class="exchange-container"
  >
    <div class="exchange-content">
      <div class="title">切换模式</div>
      <div class="des">切换模式会重置所有回合资料，是否确认切换</div>
      <div class="option">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleOk">确认</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      visible: false,
      currentIndex: 1
    };
  },
  methods: {
    handleCancel() {
      this.visible = false;
    },
    handleOk() {
      this.visible = false;
      this.$emit("ok", this.currentIndex);
    }
  }
};
</script>
<style lang="less">
.exchange-container {
  background-color: #fff;
  .el-dialog__header {
    padding: 0;
  }
  .exchange-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .title {
      margin-bottom: 13px;
      color: #333;
      font-size: 16px;
      font-weight: 600;
      line-height: 22px;
    }
    .des {
      margin-bottom: 25px;
      color: #666666;
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
    }
    .option {
      .ok-btn {
        width: 94px;
        color: #fff;
        background-color: #967a5f;
        border-color: transparent;
      }
      .cancel-btn {
        width: 94px;
        color: #967a5f;
        border-color: #967a5f;
        background-color: #fff;
      }
    }
  }
}
</style>
